
import AboutSection from '../components/AboutSection'

export default function About() {
  return (
    <div>
      <AboutSection />
    </div>
  )
}
